module.exports = __webpack_public_path__ + "img/ad-placement.018fdb01.svg";